////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

// I. FILE HEADER [WHITE #FFFFFF]
// ⚪ About Pea for Taytrom Publishing Co - Pure presentation component

// III. IMPORTS [GREEN #00FF00]
// 🟢 Third-party dependencies
import { FC } from 'react';
import styles from './TaytromPublishingCo_Kings_Home_SRC_About_Lobby_Pea.module.css';

// 🟢 Assets
import robTaylorImage from '../../../../../../shared/component/rob-taylor-image/TaytromPublishingCo_Shared_Component_RobTaylorImage.jpeg';

// IV. INDEPENDENT CONSTANTS [TEAL #00FFFF]
// 🔵 Component props interface
interface TeamMember {
  id: string;
  name: string;
  role: string;
  credentials: string[];
  bio: string;
  expertise: string[];
  photoPath?: string;
}

interface WhyTpcDifferentiator {
  id: string;
  title: string;
  description: string;
  icon: string;
  metric?: string;
}

interface ShowcaseBook {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  stats: string[];
  status: string;
  link: string;
}

interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

interface ProcessStep {
  id: string;
  number: string;
  title: string;
  description: string;
  duration: string;
}

interface PeaAboutProps {
  teamMembers: TeamMember[];
  whyTpcDifferentiators: WhyTpcDifferentiator[];
  showcaseBook: ShowcaseBook;
  processSteps: ProcessStep[];
  faqItems: FaqItem[];
  onAiInterviewStart: () => void;
  onContactRequest: () => void;
  className?: string;
}

// V. FUNCTION/CLASS NAME [BLUE #0000FF] - OUTPUT DECLARATION
// 🔵 About Pea Component
const Pea_About: FC<PeaAboutProps> = ({
  teamMembers,
  whyTpcDifferentiators,
  showcaseBook,
  processSteps,
  faqItems,
  onAiInterviewStart,
  onContactRequest,
  className
}) => {
  // X. RENDER/EXPORTS [BLACK #000000] - OUTPUT DELIVERY
  return (
    <div className={`${styles.aboutContainer} ${className || ''}`}>
      {/* Navigation Header */}
      <header className={styles.navigationHeader}>
        <div className={styles.navigationContent}>
          <a href="/" className={styles.navigationBrand}>
            <svg width="28" height="28" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}>
              <defs>
                <linearGradient id="aboutNavBulbGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="30%" style={{stopColor:'#7b1fa2',stopOpacity:1}} />
                  <stop offset="60%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="85%" style={{stopColor:'#ba68c8',stopOpacity:0.95}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:0.9}} />
                </linearGradient>
                <radialGradient id="aboutNavGlowGradient" cx="50%" cy="40%">
                  <stop offset="0%" style={{stopColor:'#ffd700',stopOpacity:0.8}} />
                  <stop offset="25%" style={{stopColor:'#ffb300',stopOpacity:0.5}} />
                  <stop offset="50%" style={{stopColor:'#9c27b0',stopOpacity:0.3}} />
                  <stop offset="100%" style={{stopColor:'#6a1b9a',stopOpacity:0}} />
                </radialGradient>
                <linearGradient id="aboutNavFilamentGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#fff9e6',stopOpacity:1}} />
                  <stop offset="20%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="aboutNavBaseGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#cfd8dc',stopOpacity:1}} />
                  <stop offset="30%" style={{stopColor:'#b0bec5',stopOpacity:1}} />
                  <stop offset="70%" style={{stopColor:'#90a4ae',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#78909c',stopOpacity:1}} />
                </linearGradient>
              </defs>
              <ellipse cx="100" cy="80" rx="75" ry="85" fill="url(#aboutNavGlowGradient)" opacity="0.3"/>
              <path d="M 100 20 C 130 20, 150 40, 150 70 C 150 90, 140 105, 130 120 C 125 130, 120 138, 120 145 L 120 155 L 80 155 L 80 145 C 80 138, 75 130, 70 120 C 60 105, 50 90, 50 70 C 50 40, 70 20, 100 20 Z" fill="url(#aboutNavBulbGradient)" stroke="rgba(255,255,255,0.4)" strokeWidth="2.5"/>
              <ellipse cx="82" cy="48" rx="22" ry="28" fill="rgba(255,255,255,0.3)" opacity="0.6"/>
              <circle cx="100" cy="65" r="3" fill="#fff9e6" opacity="0.9"/>
              <line x1="100" y1="69" x2="100" y2="85" stroke="url(#aboutNavFilamentGradient)" strokeWidth="3" strokeLinecap="round"/>
              <circle cx="90" cy="95" r="3.5" fill="url(#aboutNavFilamentGradient)"/>
              <circle cx="100" cy="95" r="3.5" fill="url(#aboutNavFilamentGradient)"/>
              <circle cx="110" cy="95" r="3.5" fill="url(#aboutNavFilamentGradient)"/>
              <line x1="100" y1="98" x2="100" y2="115" stroke="url(#aboutNavFilamentGradient)" strokeWidth="3" strokeLinecap="round"/>
              <circle cx="100" cy="120" r="3" fill="#fff9e6" opacity="0.9"/>
              <rect x="80" y="155" width="40" height="8" rx="2" fill="url(#aboutNavBaseGradient)"/>
              <rect x="80" y="165" width="40" height="6" rx="2" fill="url(#aboutNavBaseGradient)" opacity="0.85"/>
              <rect x="80" y="173" width="40" height="6" rx="2" fill="url(#aboutNavBaseGradient)" opacity="0.7"/>
            </svg>
            Taytrom Publishing Co.
          </a>
          <nav className={styles.navigationLinks}>
            <a href="/" className={styles.navigationLink}>
              Home
            </a>
            <a href="/library" className={styles.navigationLink}>
              Library
            </a>
            <a href="/ai-interviewer" className={styles.navigationLink}>
              AI Interviewer
            </a>
            <a href="/about" className={`${styles.navigationLink} ${styles.active}`}>
              About
            </a>
            <a href="/contact" className={styles.navigationLink}>
              Contact
            </a>
          </nav>
          <div className={styles.navigationActions}>
            <button onClick={onAiInterviewStart} className={styles.navigationCtaButton}>
              Start AI Interview Now
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
            <svg width="600" height="180" viewBox="0 0 800 240" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ maxWidth: '100%', height: 'auto' }}>
              <defs>
                <linearGradient id="aboutHeroTextGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="35%" style={{stopColor:'#7b1fa2',stopOpacity:1}} />
                  <stop offset="65%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="aboutHeroAccentGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                  <stop offset="50%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffb300',stopOpacity:1}} />
                </linearGradient>
                <linearGradient id="aboutHeroBulbGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#6a1b9a',stopOpacity:1}} />
                  <stop offset="60%" style={{stopColor:'#9c27b0',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:0.9}} />
                </linearGradient>
                <radialGradient id="aboutHeroGlowCompact" cx="50%" cy="40%">
                  <stop offset="0%" style={{stopColor:'#ffd700',stopOpacity:0.6}} />
                  <stop offset="100%" style={{stopColor:'#9c27b0',stopOpacity:0}} />
                </radialGradient>
                <linearGradient id="aboutHeroFilamentCompact" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" style={{stopColor:'#fff9e6',stopOpacity:1}} />
                  <stop offset="100%" style={{stopColor:'#ffd700',stopOpacity:1}} />
                </linearGradient>
              </defs>
              <ellipse cx="100" cy="120" rx="80" ry="90" fill="url(#aboutHeroGlowCompact)" opacity="0.3"/>
              <g transform="translate(20, 40)">
                <ellipse cx="80" cy="80" rx="50" ry="55" fill="url(#aboutHeroGlowCompact)" opacity="0.4"/>
                <path d="M 80 30 C 100 30, 115 42, 115 60 C 115 75, 108 85, 102 95 C 99 100, 97 105, 97 110 L 97 118 L 63 118 L 63 110 C 63 105, 61 100, 58 95 C 52 85, 45 75, 45 60 C 45 42, 60 30, 80 30 Z" fill="url(#aboutHeroBulbGradient)" stroke="rgba(255,255,255,0.3)" strokeWidth="2"/>
                <ellipse cx="70" cy="50" rx="15" ry="18" fill="rgba(255,255,255,0.3)" opacity="0.6"/>
                <circle cx="80" cy="65" r="3" fill="url(#aboutHeroFilamentCompact)"/>
                <line x1="80" y1="68" x2="80" y2="80" stroke="url(#aboutHeroFilamentCompact)" strokeWidth="2"/>
                <circle cx="75" cy="85" r="2" fill="#ffd700"/>
                <circle cx="80" cy="85" r="2" fill="#ffd700"/>
                <circle cx="85" cy="85" r="2" fill="#ffd700"/>
                <line x1="80" y1="87" x2="80" y2="95" stroke="url(#aboutHeroFilamentCompact)" strokeWidth="2"/>
                <circle cx="80" cy="98" r="3" fill="#ffd700"/>
                <rect x="63" y="118" width="34" height="7" rx="2" fill="#90a4ae"/>
                <rect x="63" y="126" width="34" height="5" rx="2" fill="#78909c" opacity="0.8"/>
                <rect x="63" y="132" width="34" height="5" rx="2" fill="#607d8b" opacity="0.6"/>
                <ellipse cx="80" cy="142" rx="7" ry="3" fill="#546e7a"/>
              </g>
              <text x="210" y="100" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="72" fontWeight="900" letterSpacing="-3" fill="url(#aboutHeroTextGradient)">TAYLOR</text>
              <text x="210" y="150" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="38" fontWeight="700" letterSpacing="-1" fill="url(#aboutHeroAccentGradient)">PUBLISHING CO.</text>
              <text x="210" y="185" fontFamily="'Inter', 'Helvetica Neue', sans-serif" fontSize="20" fontWeight="500" letterSpacing="1" fill="#cfd8dc" opacity="0.7">IDEAS THAT ILLUMINATE</text>
              <line x1="210" y1="168" x2="280" y2="168" stroke="url(#aboutHeroAccentGradient)" strokeWidth="2" opacity="0.6"/>
            </svg>
          </div>
          <h1 className={styles.heroTitle} style={{ display: 'none' }}>About Taytrom Publishing Co.</h1>
          <h2 className={styles.heroSubtitle}>
            When Investors Ask ChatGPT About Your Company, What Do They Find?
          </h2>
          <p className={styles.heroDescription}>
            AI models scrape the internet and synthesize what they find. Competitor criticism? Fragmented blog posts? Or a comprehensive 300-page authoritative analysis book from Taytrom Publishing Co. that controls your canonical narrative? We write institutional third-party documentation that AI models weight 10-100x higher than promotional content—so your story gets told correctly.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className={styles.teamSection}>
        <h3 className={styles.sectionTitle}>Leadership</h3>
        <div className={styles.teamGrid}>
          {teamMembers.map((member) => (
            <div key={member.id} className={styles.teamCard}>
              {/* Professional Headshot */}
              {member.photoPath && (
                <div className={styles.memberPhotoContainer}>
                  <img
                    src={robTaytromHeadshot}
                    alt={`${member.name} - ${member.role}`}
                    className={styles.memberPhoto}
                  />
                </div>
              )}

              <h4 className={styles.memberName}>{member.name}</h4>
              <p className={styles.memberRole}>{member.role}</p>
              <p className={styles.memberBio}>{member.bio}</p>

              {/* Credentials Section */}
              <div className={styles.credentialsSection}>
                <h5 className={styles.credentialsTitle}>Credentials:</h5>
                <ul className={styles.credentialsList}>
                  {member.credentials.map((credential, index) => (
                    <li key={index} className={styles.credentialItem}>✓ {credential}</li>
                  ))}
                </ul>
              </div>

              <div className={styles.expertiseSection}>
                <h5 className={styles.expertiseTitle}>Expertise:</h5>
                <ul className={styles.expertiseList}>
                  {member.expertise.map((skill, index) => (
                    <li key={index} className={styles.expertiseItem}>{skill}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Showcase Book Section */}
      <section className={styles.showcaseSection}>
        <h3 className={styles.sectionTitle}>Our Showcase: Proof of Capability</h3>
        <div className={styles.showcaseCard}>
          <div className={styles.showcaseContent}>
            <h4 className={styles.showcaseTitle}>{showcaseBook.title}</h4>
            <p className={styles.showcaseSubtitle}>{showcaseBook.subtitle}</p>
            <p className={styles.showcaseDescription}>{showcaseBook.description}</p>

            <div className={styles.showcaseStats}>
              {showcaseBook.stats.map((stat, index) => (
                <div key={index} className={styles.showcaseStat}>
                  <span className={styles.showcaseStatText}>{stat}</span>
                </div>
              ))}
            </div>

            <p className={styles.showcaseStatus}>
              <strong>Status:</strong> {showcaseBook.status}
            </p>

            <a href={showcaseBook.link} className={styles.showcaseButton}>
              Read Sample Chapters →
            </a>
          </div>
        </div>
      </section>

      {/* Why TPC? - Unified Differentiators Section */}
      <section className={styles.whyTpcSection}>
        <h3 className={styles.sectionTitle}>Why Taytrom Publishing Co.? Six Differentiators That Matter</h3>
        <p className={styles.whySectionSubtitle}>
          We don't just write books—we create authoritative institutional documentation that controls your narrative in the AI era.
        </p>
        <div className={styles.whyTpcGrid}>
          {whyTpcDifferentiators.map((diff) => (
            <div key={diff.id} className={styles.whyTpcCard}>
              <div className={styles.whyTpcIcon}>{diff.icon}</div>
              <h4 className={styles.whyTpcTitle}>{diff.title}</h4>
              <p className={styles.whyTpcDescription}>{diff.description}</p>
              {diff.metric && (
                <div className={styles.whyTpcMetric}>
                  <span className={styles.metricLabel}>Impact:</span>
                  <span className={styles.metricValue}>{diff.metric}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Process Timeline Section */}
      <section className={styles.processSection}>
        <h3 className={styles.sectionTitle}>The Process: 8-12 Weeks Start to Finish</h3>
        <div className={styles.processTimeline}>
          {processSteps.map((step, index) => (
            <div key={step.id} className={styles.processStep}>
              <div className={styles.processNumber}>{step.number}</div>
              <div className={styles.processContent}>
                <h4 className={styles.processTitle}>{step.title}</h4>
                <p className={styles.processDescription}>{step.description}</p>
                <span className={styles.processDuration}>{step.duration}</span>
              </div>
              {index < processSteps.length - 1 && (
                <div className={styles.processConnector}></div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* FAQ Section */}
      <section className={styles.faqSection}>
        <h3 className={styles.sectionTitle}>Frequently Asked Questions</h3>
        <div className={styles.faqGrid}>
          {faqItems.map((faq) => (
            <div key={faq.id} className={styles.faqCard}>
              <h4 className={styles.faqQuestion}>{faq.question}</h4>
              <p className={styles.faqAnswer}>{faq.answer}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <h3 className={styles.ctaTitle}>Book Your Slot: Limited to 10 Projects Per Quarter</h3>
        <p className={styles.ctaDescription}>
          Rob Taytrom personally writes every book. To maintain quality, we accept only 10 client projects per quarter (current availability: 3 slots remaining for Q1 2026). Start your AI interview now to secure your comprehensive third-party analysis book before your competitors realize this is the AI-era imperative.
        </p>
        <div className={styles.ctaButtons}>
          <button onClick={onAiInterviewStart} className={`${styles.ctaButton} ${styles.primary}`}>
            Start AI Interview Now
          </button>
          <button onClick={onContactRequest} className={`${styles.ctaButton} ${styles.secondary}`}>
            Book a Consultation
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.aboutFooter}>
        <p>© 2025 Taytrom Publishing Co. All rights reserved.</p>
        <p>Comprehensive third-party analysis books for the AI era.</p>
      </footer>
    </div>
  );
};

export default Pea_About;
